"use client";

import type { ReactNode } from "react";
import { Box, styled, Typography } from "@mui/material";

const FormTitle = styled(Box)({
  marginBottom: "8px",

  "& span": {
    paddingLeft: "2px",
    color: "red",
  },
});

interface FormFieldTitleProps {
  children: ReactNode;
  /** Adds a red asterisk. */
  required?: boolean;
}

const FormFieldTitle = ({ children, required = false }: FormFieldTitleProps) => (
  <FormTitle>
    <Typography variant="h4">
      {children}
      {required && <span>*</span>}
    </Typography>
  </FormTitle>
);

export default FormFieldTitle;
